module.exports = __webpack_public_path__ + "images/store_case_study/ucs-pic1_b332c70a35fd08849a706aae40aaf92f.png";